import React from 'react'
import { Columns } from 'labguard-cdk'

export const id = 'page-options'

const PageOptionsTarget = () => <Columns align="center" id={id} />

export default PageOptionsTarget
